import React from 'react';
import Row from 'components/UIKit/Flex/Row';
import Column from 'components/UIKit/Flex/Column';
import { DynamicEntityLink } from 'components/Links';
import CaseIcon from 'components/icons/CaseIcon';
import TreeDownLevelIcon from 'components/icons/TreeDownLevelIcon';
import { IconRegistry } from 'components/icons';

function Hierarchy({ hierarchy, entity, relatedEntities, defs }) {
  let relatedCase = ((entity || {})._related_cases || [])[0];

  const CasesLink = DynamicEntityLink("case", "browse");

  return (
    <Column>
      <Row style={{ alignItems: 'center' }}>
        { !!relatedCase &&
          <Row>
            <CaseIcon style={{ fontSize: '1rem', marginRight: '.2rem' }} />
            <CasesLink query={{ did: relatedCase.id, id: relatedCase.id }}>
              { relatedCase.submitter_id }
            </CasesLink>
          </Row>
        }
      </Row>

      { hierarchy.reduce((p, c, i) => [...p,
        ...(c.map((def) => {
          return relatedEntities
            .filter(x => x[def.entity] || x.type === def.entity)
            .map(relatedEntity => {
              let relatedEntityValue = (relatedEntity || [{}])[def.entity];
              let e = (relatedEntityValue || [])[0] || entity;
              let EntityIcon = IconRegistry(def.entity, defs);
              const LinkComponent = DynamicEntityLink(e.type, "browse")
              return (
                <Column key={ e.id } style={{ marginLeft: `${i * 1}rem` }}>
                  <Row style={{ alignItems: 'center' }}>
                    <TreeDownLevelIcon style={{ margin: '0 .2rem 0 .1rem', fontSize: '1rem' }} />
                    <EntityIcon style={{ fontSize: '1rem', marginRight: '.5rem' }} />
                    { e.id !== entity.id &&
                    <LinkComponent query={{ id: e.id, did: e.id }}>
                      { e.submitter_id }
                    </LinkComponent>
                    }
                    { e.id === entity.id && <Row>{ e.submitter_id }</Row> }
                  </Row>
                </Column>
              );
            });
        }))
      ], [])
      }
    </Column>
  );
}

export default Hierarchy;
